/**
 * @since 2.0.0
 */
import * as internal from "./internal/logSpan.js";
/**
 * @since 2.0.0
 * @category constructors
 */
export const make = internal.make;
/**
 * @since 2.0.0
 * @category destructors
 */
export const render = internal.render;
//# sourceMappingURL=LogSpan.js.map